// extracted by mini-css-extract-plugin
export default {"title":"Team__title-Dte0","teamBox":"Team__teamBox-JcJW","description":"Team__description-IXDT","teamBg":"Team__teamBg-ir51","inner":"Team__inner-lzOM"};